import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import cx from 'classnames';

import moment from 'moment';

import { Button, Checkbox, Field, Icon, Radios, Tag, Spacer } from '@ontruck/orc';

import { VEHICLE_STATES } from '../CarrierDetails/Constants';

import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from '@ontruck/ontruck-react-components/lib/Modal';

import { Column, Row, Section, SectionTitle } from '../ModalFormLayout';

import { allowOnlyNumbersAndDot } from 'utils/forms';
import ReasonDeleteModal from 'components/ReasonDeleteModal';
import DocumentsList from '../DocumentsList';
import { getVehicleDocuments } from './http';
import { Loading } from 'components/Loading';
import COUNTRIES from 'utils/countries.json';
import Select from 'react-select-v3';
import { reactSelectStyles } from 'utils/style';
import {
  VEHICLE_CONTAINER_LENTH,
  VEHICLE_ENGINE_TYPES,
  VEHICLE_EURO_CATEGORIES,
} from './constants';
import DateField from 'components/DateField';
import { ReactComponent as Extensible } from 'assets/icons/tenant/vehicle-type-ext.svg';
import { ReactComponent as Short } from 'assets/icons/tenant/vehicle-type-short.svg';
import { ReactComponent as Normal } from 'assets/icons/tenant/vehicle-type-norm.svg';
import { VEHICLE_TYPES } from 'utils/vehicle_types';
import { useSelector } from 'react-redux';
import { constants, getSpecificClientConfig } from 'redux/modules/client-config/selectors';
class CarrierVehicleEditModal extends Component {
  static propTypes = {
    className: PropTypes.string,
    vehicle: PropTypes.object,
    availableVehiclesTypes: PropTypes.object,
    intl: PropTypes.any,
    carrier: PropTypes.object,
    onClose: PropTypes.func,
    onSave: PropTypes.func,
    onSaveSuccesfully: PropTypes.func,
    allowStateUpdate: PropTypes.bool,
    remove: PropTypes.func,
  };

  constructor(props) {
    super(props);
    const { vehicle, isDocumentationEnabled } = props;

    this.state = {
      vehicle: {
        ...vehicle,
        temperature_details: (vehicle && vehicle.temperature_details) || {},
      },
      fieldErrors: [],
      submitting: false,
      server_errors: {},
      showDeleteModal: false,
      documents: [],
      documentsLoading: false,
      isDocumentationEnabled,
    };

    this.handleFieldChange = this.handleFieldChange.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.showFieldError = this.showFieldError.bind(this);
    this.validate = this.validate.bind(this);
    this.handleServerError = this.handleServerError.bind(this);
    this.getRegisterCountryValue = this.getRegisterCountryValue.bind(this);
    this.getEngineTypeValue = this.getEngineTypeValue.bind(this);
    this.getEuroCategoryValue = this.getEuroCategoryValue.bind(this);
    this.getDocuments = this.getDocuments.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
  }

  componentDidMount() {
    if (this.state.vehicle?.id && this.state.isDocumentationEnabled) {
      this.getDocuments();
    }
  }

  showFieldError(field) {
    const { fieldErrors } = this.state;
    return fieldErrors.indexOf(field) !== -1;
  }

  validate() {
    const { vehicle } = this.state;

    const validDate = (value) => !value || moment(value).isValid();
    const dateFromThePast = (value) => !value || moment(value).isSameOrBefore(moment());

    const validations = {
      plate_number: (value) => value && value !== '',
      vehicle_type: (value) => value && value !== '',
      insurance_expiration: validDate,
      road_permit_expiration: validDate,
      conformity_expiration: validDate,
      transport_card_expiration: validDate,
      itv_expiration: validDate,
      registration_date: dateFromThePast,
    };

    return new Promise((resolve, reject) => {
      const fieldErrors = Object.keys(validations)
        .map((field) => (validations[field](vehicle[field], vehicle) ? null : field))
        .filter((error) => error);

      if (fieldErrors.length === 0) {
        resolve();
      } else {
        this.setState(
          {
            fieldErrors,
          },
          () => reject(fieldErrors)
        );
      }
    });
  }

  async getDocuments() {
    const { vehicle } = this.state;
    try {
      this.setState({
        documentsLoading: true,
      });
      const documents = await getVehicleDocuments(vehicle.id);
      this.setState({
        documents,
      });
    } catch (e) {
      console.error('Error getting documents', e);
    } finally {
      this.setState({
        documentsLoading: false,
      });
    }
  }

  handleServerError(errors) {
    this.setState({
      server_errors: errors,
    });
  }

  handleSave(isAddVehicleLite) {
    const { onSave, onSaveSuccesfully } = this.props;
    if (!onSave) {
      return;
    }

    const { vehicle } = this.state;
    if (isAddVehicleLite) delete vehicle.max_pallets;

    this.validate()
      .then(() =>
        this.setState({ submitting: true }, () =>
          onSave(vehicle)
            .then(onSaveSuccesfully)
            .catch((err) => {
              console.error(err);
              return err.response.json().then(this.handleServerError);
            })
            .catch((error) => console.error(error)) // Catch any possible errors above. This is BAD code
            .then(() => this.setState({ submitting: false }))
        )
      )
      .catch((err) => {
        console.error(err);
      });
  }

  handleRemove() {
    const { remove } = this.props;

    if (!remove) {
      return;
    }

    const { vehicle } = this.state;

    remove({ id: vehicle.id });
  }

  handleFieldChange(
    field,
    clearErrors = [],
    cb = () => {
      /*noop*/
    }
  ) {
    return (value) => {
      const { vehicle, fieldErrors } = this.state;
      this.setState(
        {
          vehicle: {
            ...vehicle,
            [field]: value === '' ? null : value,
          },
          fieldErrors: fieldErrors.filter(
            (error) => clearErrors.concat(field).indexOf(error) === -1
          ),
          server_errors: {},
        },
        cb
      );
    };
  }

  handleMultipleFieldsChange(
    field,
    clearErrors = [],
    cb = () => {
      /*noop*/
    }
  ) {
    return (values) => {
      const { vehicle, fieldErrors } = this.state;
      this.setState(
        {
          vehicle: {
            ...vehicle,
            ...values,
          },
          fieldErrors: fieldErrors.filter(
            (error) => clearErrors.concat(field).indexOf(error) === -1
          ),
          server_errors: {},
        },
        cb
      );
    };
  }

  getRegisterCountryValue() {
    return (
      COUNTRIES.find((country) => country['alpha-2'] === this.state.vehicle.registration_country) ||
      null
    );
  }

  getEngineTypeValue() {
    return (
      VEHICLE_ENGINE_TYPES.find((item) => item.value === this.state.vehicle.engine_type) || null
    );
  }

  getEuroCategoryValue() {
    return (
      VEHICLE_EURO_CATEGORIES.find((item) => item.value === this.state.vehicle.euro_category) ||
      null
    );
  }

  render() {
    const {
      onClose,
      carrier,
      availableVehiclesTypes,
      intl,
      className,
      allowStateUpdate,
      isAddVehicleLite,
    } = this.props;
    const { vehicle, submitting, server_errors, documents, documentsLoading } = this.state;
    const t = intl.messages.components.VehicleEditModal;

    let vehicleType;
    if (isAddVehicleLite) {
      vehicleType = (availableVehiclesTypes[carrier.country] || []).filter((type) =>
        [VEHICLE_TYPES.TRACTOR_UNIT, VEHICLE_TYPES.TRAILER].includes(type)
      );
    } else {
      vehicleType = availableVehiclesTypes[carrier.country] || [];
    }

    return (
      <div data-testid="editVehicleModal">
        <Modal show={true} size="L" onClose={onClose} className={className}>
          <div className="carrier-vehicle-edit-modal">
            <ModalHeader>{vehicle.id ? t.titles.modal_edit : t.titles.modal_new}</ModalHeader>
            <ModalBody noPadding light>
              <Section className="carrier-vehicle-edit-modal__section carrier-vehicle-edit-modal__section--dark">
                <Row>
                  <Column>
                    <SectionTitle className="carrier-vehicle-edit-modal__title">
                      {t.titles.vehicle_status}
                    </SectionTitle>
                    {vehicle.status !== VEHICLE_STATES.carrier_banned && (
                      <Radios
                        name="status"
                        size="M"
                        girded
                        value={vehicle.status}
                        items={[
                          { value: VEHICLE_STATES.active, label: t.titles.active },
                          { value: VEHICLE_STATES.not_active, label: t.titles.not_active },
                        ]}
                        onChange={(e, { name, value }) =>
                          this.handleFieldChange('status')(value.toString())
                        }
                        disabled={!allowStateUpdate}
                      />
                    )}
                    {vehicle.status === VEHICLE_STATES.carrier_banned && (
                      <Tag
                        text={t.states.carrier_banned.toUpperCase()}
                        skin="modernRed"
                        weight="bold"
                        size="M"
                      />
                    )}
                  </Column>
                </Row>
              </Section>
              <Section className="carrier-vehicle-edit-modal__section">
                <Row>
                  <Column>
                    <SectionTitle className="carrier-vehicle-edit-modal__title">
                      {t.titles.specs}
                    </SectionTitle>
                    {this.showFieldError('vehicle_type') ? (
                      <div className="carrier-vehicle-edit-modal__vehicle-error">
                        <Icon
                          name="alert"
                          className="carrier-vehicle-edit-modal__vehicle-error-icon"
                        />{' '}
                        {t.errors.vehicle_type}
                      </div>
                    ) : null}
                    <Radios
                      name="status"
                      size="M"
                      girded
                      value={vehicle.vehicle_type}
                      className={cx('carrier-vehicle-edit-modal__type-container', {
                        'carrier-vehicle-edit-modal__error': this.showFieldError('vehicle_type'),
                      })}
                      items={vehicleType.map((type) => {
                        return { value: type, label: t.labels.vehicle_types[type] };
                      })}
                      onChange={(e, { name, value }) =>
                        this.handleFieldChange('vehicle_type')(value)
                      }
                    />
                  </Column>
                </Row>
                <Row>
                  <Column>
                    <div className="carrier-vehicle-edit-modal__row">
                      <Field
                        onChange={(e, { value }) => this.handleFieldChange('zipcode')(value)}
                        className="carrier-vehicle-edit-modal__input carrier-vehicle-edit-modal__input--size-M"
                        name="zipcode"
                        id="zipcode"
                        value={vehicle.zipcode}
                        label={t.labels.zipcode}
                        size="M"
                      />
                      <Field
                        id="plate_number"
                        name="plate_number"
                        size="M"
                        label={t.labels.plate_number}
                        className="carrier-vehicle-edit-modal__input carrier-vehicle-edit-modal__input--size-L"
                        value={(vehicle.plate_number && vehicle.plate_number.toUpperCase()) || ''}
                        onChange={(e, { value }) => this.handleFieldChange('plate_number')(value)}
                        error={
                          (this.showFieldError('plate_number') && t.errors.plate_number) || null
                        }
                      />
                      <Field
                        id="model"
                        name="model"
                        label={t.labels.model}
                        value={vehicle.model || ''}
                        className="carrier-vehicle-edit-modal__input carrier-vehicle-edit-modal__input--size-L"
                        onChange={(e, { value }) => this.handleFieldChange('model')(value)}
                        size="M"
                      />
                    </div>
                  </Column>
                </Row>
                {!isAddVehicleLite && (
                  <Row>
                    <div className="carrier-vehicle-edit-modal__row">
                      <SectionTitle className="carrier-vehicle-edit-modal__title">
                        {t.titles.extras}
                      </SectionTitle>
                      <Checkbox
                        label={t.labels.has_liftgate}
                        boxed
                        girded
                        name="extras-liftgate"
                        checked={vehicle.has_liftgate}
                        icon="extras-liftgate"
                        onChange={(e, { name, value }) =>
                          this.handleFieldChange('has_liftgate')(value)
                        }
                      />
                      <Checkbox
                        label={t.labels.has_lateral_loading}
                        boxed
                        girded
                        name="extras-sideload"
                        icon="extras-sideload"
                        checked={vehicle.has_lateral_loading}
                        onChange={(e, { name, value }) =>
                          this.handleFieldChange('has_lateral_loading')(value)
                        }
                      />
                      <Checkbox
                        label={t.labels.has_superior_loading}
                        boxed
                        girded
                        name="extras-retractableroof"
                        icon="extras-retractableroof"
                        checked={vehicle.has_superior_loading}
                        onChange={(e, { name, value }) =>
                          this.handleFieldChange('has_superior_loading')(value)
                        }
                      />
                    </div>
                  </Row>
                )}
                {isAddVehicleLite && (
                  <Row>
                    <div className="carrier-vehicle-edit-modal__row">
                      <SectionTitle className="carrier-vehicle-edit-modal__title">
                        {t.titles.platform}
                      </SectionTitle>
                      <Checkbox
                        label={
                          <>
                            <Short /> 20 pulgadas
                          </>
                        }
                        boxed
                        girded
                        name="short-platform"
                        checked={vehicle.is_short_platform}
                        onChange={(e, { name, value }) =>
                          this.handleMultipleFieldsChange('is_platform')({
                            is_platform: value,
                            is_short_platform: value,
                            is_extensible: false,
                            container_length: VEHICLE_CONTAINER_LENTH.twentyFeet,
                          })
                        }
                      />
                      <Checkbox
                        label={
                          <>
                            <Normal /> 40 pulgadas
                          </>
                        }
                        boxed
                        girded
                        name="normal-platform"
                        checked={
                          vehicle.is_platform &&
                          !vehicle.is_short_platform &&
                          !vehicle.is_extensible
                        }
                        onChange={(e, { name, value }) =>
                          this.handleMultipleFieldsChange('is_platform')({
                            is_platform: value,
                            is_short_platform: false,
                            is_extensible: false,
                            container_length: VEHICLE_CONTAINER_LENTH.fourtyFeet,
                          })
                        }
                      />
                      <Checkbox
                        label={
                          <>
                            <Extensible /> Extensible
                          </>
                        }
                        boxed
                        girded
                        name="extensible-platform"
                        checked={vehicle.is_extensible}
                        onChange={(e, { name, value }) =>
                          this.handleMultipleFieldsChange('is_platform')({
                            is_platform: value,
                            is_short_platform: false,
                            is_extensible: value,
                            container_length: VEHICLE_CONTAINER_LENTH.extensible,
                          })
                        }
                      />
                    </div>
                  </Row>
                )}

                {vehicle.vehicle_type !== 'tractor_unit' && (
                  <Row>
                    <div className="carrier-vehicle-edit-modal__row-container">
                      <SectionTitle className="carrier-vehicle-edit-modal__title">
                        {t.titles.load_capacity}
                      </SectionTitle>
                      <div className="carrier-vehicle-edit-modal__row-inputs">
                        <Field
                          id="max_weight"
                          name="max_weight"
                          label={t.labels.max_weight}
                          helpText={t.labels.max_weight_help}
                          className="carrier-vehicle-edit-modal__input carrier-vehicle-edit-modal__input--size-S"
                          value={parseInt(vehicle.max_weight, 10) || ''}
                          onChange={(e, { value }) => this.handleFieldChange('max_weight')(value)}
                          size="M"
                          {...allowOnlyNumbersAndDot}
                        />
                        {!isAddVehicleLite && (
                          <>
                            <Field
                              id="max_pallets"
                              name="max_pallets"
                              label={t.labels.max_pallets}
                              className="carrier-vehicle-edit-modal__input carrier-vehicle-edit-modal__input--size-S"
                              value={vehicle.max_pallets || ''}
                              onChange={(e, { value }) =>
                                this.handleFieldChange('max_pallets')(value)
                              }
                              {...allowOnlyNumbersAndDot}
                              size="M"
                            />
                            <Field
                              id="container_width"
                              name="container_width"
                              label={t.labels.container_width}
                              helpText={t.labels.container_width_help}
                              className="carrier-vehicle-edit-modal__input carrier-vehicle-edit-modal__input--size-S"
                              value={vehicle.container_width || ''}
                              onChange={(e, { value }) =>
                                this.handleFieldChange('container_width')(value)
                              }
                              {...allowOnlyNumbersAndDot}
                              size="M"
                            />
                          </>
                        )}
                        <Field
                          id="container_height"
                          name="container_height"
                          label={t.labels.container_height}
                          helpText={t.labels.container_height_help}
                          className="carrier-vehicle-edit-modal__input carrier-vehicle-edit-modal__input--size-S"
                          value={vehicle.container_height || ''}
                          onChange={(e, { value }) =>
                            this.handleFieldChange('container_height')(value)
                          }
                          {...allowOnlyNumbersAndDot}
                          size="M"
                        />
                        {!isAddVehicleLite && (
                          <>
                            <Field
                              id="container_length"
                              name="container_length"
                              label={t.labels.container_length}
                              helpText={t.labels.container_length_help}
                              className="carrier-vehicle-edit-modal__input carrier-vehicle-edit-modal__input--size-S"
                              value={vehicle.container_length || ''}
                              onChange={(e, { value }) =>
                                this.handleFieldChange('container_length')(value)
                              }
                              {...allowOnlyNumbersAndDot}
                              size="M"
                            />
                            <Field
                              id="length"
                              name="length"
                              label={t.labels['length']}
                              helpText={t.labels.length_help}
                              className="carrier-vehicle-edit-modal__input carrier-vehicle-edit-modal__input--size-S"
                              value={vehicle.length || ''}
                              onChange={(e, { value }) => this.handleFieldChange('length')(value)}
                              {...allowOnlyNumbersAndDot}
                              size="M"
                            />
                          </>
                        )}
                        <Field
                          id="mma"
                          name="mma"
                          label={t.labels.mma}
                          helpText={t.labels.mma_help}
                          className="carrier-vehicle-edit-modal__input carrier-vehicle-edit-modal__input--size-S"
                          value={parseInt(vehicle.mma, 10) || ''}
                          onChange={(e, { value }) => this.handleFieldChange('mma')(value)}
                          {...allowOnlyNumbersAndDot}
                          size="M"
                        />
                      </div>
                    </div>
                  </Row>
                )}
              </Section>
              <Section className="carrier-vehicle-edit-modal__section">
                <Row>
                  <div
                    className="carrier-vehicle-edit-modal__row"
                    data-testid="carrier-vehicle-edit-modal__technical-row"
                  >
                    <SectionTitle className="carrier-vehicle-edit-modal__title">
                      {t.titles.tech_data}
                    </SectionTitle>
                    <Column third>
                      <label className="carrier-vehicle-edit-modal__select-label">
                        {t.labels.engineType}
                      </label>
                      <Select
                        className="carrier-vehicle-edit-modal__select"
                        containerWidth="auto"
                        label={t.labels.engineType}
                        placeholder={t.labels.engineType}
                        name="engine_type"
                        value={this.getEngineTypeValue()}
                        options={VEHICLE_ENGINE_TYPES}
                        onChange={(selectedOption) =>
                          this.handleFieldChange('engine_type')(selectedOption.value)
                        }
                        styles={reactSelectStyles}
                      />
                    </Column>
                    <Column third>
                      <label className="carrier-vehicle-edit-modal__select-label">
                        {t.labels.euroCategory}
                      </label>
                      <Select
                        className="carrier-vehicle-edit-modal__select"
                        containerWidth="auto"
                        label={t.labels.euroCategory}
                        placeholder={t.labels.euroCategory}
                        name="euro_category"
                        value={this.getEuroCategoryValue()}
                        options={VEHICLE_EURO_CATEGORIES}
                        onChange={(selectedOption) =>
                          this.handleFieldChange('euro_category')(selectedOption.value)
                        }
                        styles={reactSelectStyles}
                      />
                    </Column>
                    <Column third>
                      <DateField
                        labelClass="carrier-vehicle-edit-modal__date-label"
                        label={t.labels.registrationDate}
                        value={vehicle.registration_date}
                        onChange={(value) => {
                          const formatValue = moment(value).format('YYYY-MM-DD');
                          this.handleFieldChange('registration_date')(formatValue);
                        }}
                        size="M"
                        error={
                          (this.showFieldError('registration_date') &&
                            t.errors.registration_date) ||
                          null
                        }
                      />
                    </Column>
                    <Column>
                      <label className="carrier-vehicle-edit-modal__select-label">
                        {t.labels.registration_country}
                      </label>
                      <Select
                        className="carrier-vehicle-edit-modal__select"
                        containerWidth="auto"
                        placeholder={t.labels.registration_country}
                        name="registration_country"
                        value={this.getRegisterCountryValue()}
                        options={COUNTRIES}
                        onChange={(selectedOption) =>
                          this.handleFieldChange('registration_country')(selectedOption['alpha-2'])
                        }
                        styles={reactSelectStyles}
                        getOptionLabel={(o) => o.name}
                        getOptionValue={(o) => o['alpha-2']}
                      />
                    </Column>
                  </div>
                </Row>
              </Section>
              {!isAddVehicleLite && (
                <Section className="carrier-vehicle-edit-modal__section">
                  <Row>
                    <div className="carrier-vehicle-edit-modal__row">
                      <SectionTitle className="carrier-vehicle-edit-modal__title">
                        {t.titles.docs}
                      </SectionTitle>
                      <div className="carrier-vehicle-edit-modal__documents-list">
                        {documentsLoading ? (
                          <Spacer mBottom="S">
                            <Loading />
                          </Spacer>
                        ) : (
                          <DocumentsList
                            serverDocuments={documents}
                            entity={{
                              entity_id: vehicle.id,
                              entity_type: 'vehicle',
                              entity_uuid: vehicle.uuid,
                            }}
                            refreshDocuments={this.getDocuments}
                            landingLink={carrier.landing_link}
                          />
                        )}
                      </div>
                      <div className="carrier-vehicle-edit-modal__column carrier-vehicle-edit-modal__column--left">
                        {carrier && carrier.google_drive_link ? (
                          <Button
                            nude
                            href={carrier.google_drive_link}
                            skin="primary"
                            className={'carrier-vehicle-edit-modal__doc-link'}
                            target="_blank"
                            text={t.labels.google_drive_link}
                          />
                        ) : null}
                      </div>
                    </div>
                  </Row>
                </Section>
              )}
            </ModalBody>
            <ModalFooter light>
              {Object.keys(server_errors).length ? (
                <div className={'carrier-vehicle-edit-modal__general-errors'}>
                  <div>
                    {Object.keys(server_errors).map((error) => (
                      <div>
                        <strong>{error}</strong>: {server_errors[error]}
                      </div>
                    ))}
                  </div>
                </div>
              ) : null}
              <div className="carrier-vehicle-edit-modal__footer-actions">
                {vehicle.id && (
                  <span className="carrier-vehicle-edit-modal__delete-btn">
                    <Button
                      nude
                      text={t.delete}
                      data-testid="carrier-vehicle-edit-modal__button-modal"
                      onClick={() => this.setState({ showDeleteModal: true })}
                    />
                  </span>
                )}
                <Button
                  data-testid="editVehicleModal__submit"
                  onClick={() => this.handleSave(isAddVehicleLite)}
                  disabled={submitting}
                  text={vehicle.id ? t.save_edit : t.save_new}
                />
              </div>
            </ModalFooter>
          </div>
        </Modal>
        <ReasonDeleteModal
          show={this.state.showDeleteModal}
          onClose={() => this.setState({ showDeleteModal: false })}
          disabled={submitting}
          onSave={(reason) => {
            this.setState(
              {
                removeVehicle: {
                  ...this.state.vehicle,
                  remove_reason: reason,
                  status: VEHICLE_STATES.removed,
                },
              },
              this.handleRemove
            );
          }}
        />
      </div>
    );
  }
}

const HookHOCWrapper = (props) => {
  //allow use of hooks inside classes
  const isDocumentationEnabled = useSelector((state) =>
    getSpecificClientConfig(state, constants.DOCS_TAB)
  );

  const newProps = {
    ...props,
    isDocumentationEnabled,
  };

  return <CarrierVehicleEditModal {...newProps} />;
};

export default injectIntl(HookHOCWrapper);
